export default "__VITE_ASSET__3a598369__"